import {Component, OnInit} from '@angular/core';
import {IndividuService, PubSubService} from '@Common/core/services';
import {Individu} from '@Common/core/services';
import {Menu} from '@Common/home/models/menu.model';
import {rolesDar} from './common/services/roles';

import {ManageRoleDarService} from './common/services/roles/manage-roles.service';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import { Location } from '@angular/common';
import {ComponentItem} from "@Common/home/navbar/dynamic-core-components/component-item";
import {MenuNavComponent} from "@Common/home/navbar/components/menu-nav.component";
import {ComponentsService} from "@Services/navbar/components-navbar.service";
import {ReminderDarNavComponent} from "app/dar/accueil/reminder-dar-nav/reminder-dar-nav.component";

@Component({
  selector: 'app-dar-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Demande d\'Autorisation de Recrutement';
  menu: Menu[];

  individu: Individu;

  showLoader = false;
  subloading: Subscription;

  constructor(public router: Router,
              private pubSubSvc: PubSubService,
              private individuService: IndividuService,
              private rolesSvc: ManageRoleDarService,
              private componentsService: ComponentsService,
              private location: Location) {
  }

  ngOnInit(): void {
    this.subloading = this.pubSubSvc.on('loading').subscribe((val) => {
      setTimeout(() => this.showLoader = val);
    });

    this.individuService.individu$.subscribe(individu => {
      this.setMenu(individu);
      this.redirectUser(individu);
    });
  }

  /**
   * Mes demandes : tout profil même gestionnaire (sauf commission [?])
   * Tout rôle de gestion accède au traitement des demandes
   * @param individu
   */
  setMenu(individu: Individu) {
    this.menu = [];
    if (!this.individuService.hasRole(individu, rolesDar.commission_consult)) {
      this.menu.push({url: '/mes-demandes', titre: 'Mes demandes', nav: true, icon: 'source'});
    }
    if ((this.rolesSvc.hasRoleFonctionnel(individu) || this.individuService.hasRole(individu, rolesDar.dvc))
      && !this.individuService.hasRole(individu, rolesDar.commission_consult)) {
      this.menu.push(
        {url: '/gestion/traitements-demandes', titre: 'Demandes à traiter', nav: false, icon: 'reorder'},
      );
    }
    if (this.individuService.hasRole(individu, rolesDar.commission) ||
      this.individuService.hasRole(individu, rolesDar.commission_consult)) {
      this.menu.push(
        {url: '/gestion/commission', titre: 'Commission', nav: false, icon: 'checklist_rtl'},
      );
    }
    if (this.rolesSvc.hasRole(individu, rolesDar.masse_salariale) ||
      this.rolesSvc.hasRole(individu, rolesDar.sbtcp) ||
      this.rolesSvc.hasRole(individu, rolesDar.drh) ||
      this.rolesSvc.isGestionnaire(individu)) {
      this.menu.push({url: '/gestion/indicateurs', titre: 'Indicateurs', nav: false, icon: 'show_chart'});
    }
    if (this.rolesSvc.isGestionnaire(individu)) {
      this.menu.push(
        {url: '/gestion/demandes-sans-suite', titre: 'Demandes classées sans suite', nav: false, icon: 'archive'},
        {url: '/admin', titre: 'Paramétrage', nav: false, icon: 'settings_suggest'},
      );
    }
    this.menu.push({url: '/notification', titre: 'Notifications', nav: false, icon: 'add_alert'});
    this.menu.push({url: '/aide', titre: 'Aide', nav: false, icon: 'help'});

    const components = [
      new ComponentItem(MenuNavComponent, this.menu)
    ];
    components.push(new ComponentItem(ReminderDarNavComponent, {}, 'remindersDar'));
    this.componentsService.setComponents(components);
  }

  redirectUser(individu) {
    if (this.location.path()) {
      return;
    }
    if (! this.rolesSvc.hasRoleFonctionnel(individu)) {
      this.router.navigate(['mes-demandes']);
    } else {

      if (this.individuService.hasRole(individu, rolesDar.commission_consult)) {
        this.router.navigate(['gestion/commission']);
        return;
      }

      if (this.rolesSvc.hasRoleFonctionnel(individu)) {
        this.router.navigate(['gestion/traitements-demandes']);
        return;
      }
    }
  }
}
